import { isDevMode } from '@angular/core';

import { routerReducer } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as languages from './reducers/languages.reducer';
import * as setting from './reducers/setting.reducer';
import { IAppState } from './states/app.state';

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    // if (action.type === '[language] Set language') {
    //   state = {}
    // }
    return reducer(state, action);
  };
}

export const metaReducers: Array<MetaReducer<any>> = !isDevMode() ? [] : [logger];

export const reducers: ActionReducerMap<IAppState> = {
  [languages.featureKey]: languages.reducer,
  [setting.featureKey]: setting.reducer,
  router: routerReducer,
};
